(function () {
  'use strict';

  // ─── Konfiguration ──────────────────────────────────────────────────────────
  // Unterstützt sowohl direktes Einbinden als auch defer-Attribut
  function getScript() {
    if (document.currentScript) return document.currentScript;
    const all = document.querySelectorAll('script[data-backend-url]');
    return all[all.length - 1] || null;
  }
  const scriptEl = getScript();
  const BACKEND = (scriptEl && scriptEl.getAttribute('data-backend-url')) || 'https://aredo-chatbot-production.up.railway.app';

  const WELCOME = 'Herzlich willkommen bei Aredo! Ich bin Ihr persönlicher Showroom-Berater und helfe Ihnen gerne, das perfekte Möbelstück für Ihr Zuhause zu finden. Womit kann ich Ihnen heute behilflich sein?';

  // ─── State ──────────────────────────────────────────────────────────────────
  var history = [];
  var isOpen = false;
  var isLoading = false;
  var welcomed = false;

  // ─── Styles ─────────────────────────────────────────────────────────────────
  var CSS = [
    /* Trigger-Button */
    '#ac-trigger{position:fixed;bottom:24px;right:24px;width:60px;height:60px;',
    'border-radius:50%;background:#1A1A1A;border:none;cursor:pointer;',
    'display:flex;align-items:center;justify-content:center;',
    'box-shadow:0 4px 20px rgba(0,0,0,0.28);z-index:99998;',
    'transition:transform 0.2s ease,box-shadow 0.2s ease;outline:none;}',
    '#ac-trigger:hover{transform:scale(1.06);box-shadow:0 6px 28px rgba(0,0,0,0.35);}',
    '#ac-trigger svg{pointer-events:none;}',

    /* Chat-Fenster */
    '#ac-window{position:fixed;bottom:100px;right:24px;width:380px;height:548px;',
    'background:#fff;border-radius:16px;',
    'box-shadow:0 16px 56px rgba(0,0,0,0.14),0 4px 16px rgba(0,0,0,0.08);',
    'display:flex;flex-direction:column;z-index:99999;overflow:hidden;',
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;',
    'opacity:0;transform:translateY(18px) scale(0.97);pointer-events:none;',
    'transition:opacity 0.22s ease,transform 0.22s ease;}',
    '#ac-window.ac-open{opacity:1;transform:translateY(0) scale(1);pointer-events:all;}',

    /* Header */
    '#ac-header{background:#1A1A1A;padding:15px 18px;display:flex;',
    'align-items:center;justify-content:space-between;flex-shrink:0;}',
    '.ac-header-left{display:flex;align-items:center;gap:11px;}',
    '.ac-avatar{width:38px;height:38px;border-radius:50%;background:#B8A48A;',
    'display:flex;align-items:center;justify-content:center;',
    'color:#fff;font-size:14px;font-weight:700;letter-spacing:0.5px;flex-shrink:0;}',
    '.ac-header-info{display:flex;flex-direction:column;}',
    '.ac-header-name{color:#fff;font-size:13.5px;font-weight:600;letter-spacing:0.2px;}',
    '.ac-header-sub{color:rgba(255,255,255,0.5);font-size:11px;margin-top:2px;}',
    '#ac-close{background:none;border:none;color:rgba(255,255,255,0.55);cursor:pointer;',
    'padding:5px;display:flex;align-items:center;border-radius:5px;',
    'transition:color 0.15s ease;outline:none;}',
    '#ac-close:hover{color:#fff;}',

    /* Nachrichten-Bereich */
    '#ac-messages{flex:1;overflow-y:auto;padding:18px 14px;background:#FAFAF7;',
    'display:flex;flex-direction:column;gap:11px;}',
    '#ac-messages::-webkit-scrollbar{width:4px;}',
    '#ac-messages::-webkit-scrollbar-track{background:transparent;}',
    '#ac-messages::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.13);border-radius:2px;}',

    /* Nachrichten-Bubbles */
    '.ac-msg{display:flex;flex-direction:column;max-width:86%;',
    'animation:ac-in 0.18s ease;}',
    '@keyframes ac-in{from{opacity:0;transform:translateY(7px)}to{opacity:1;transform:translateY(0)}}',
    '.ac-msg.ac-bot{align-self:flex-start;}',
    '.ac-msg.ac-user{align-self:flex-end;}',
    '.ac-bubble{padding:10px 14px;border-radius:14px;font-size:13.5px;',
    'line-height:1.57;color:#2C2C2C;word-wrap:break-word;}',
    '.ac-bot .ac-bubble{background:#fff;border-bottom-left-radius:4px;',
    'box-shadow:0 1px 4px rgba(0,0,0,0.09),0 2px 14px rgba(0,0,0,0.05);}',
    '.ac-user .ac-bubble{background:#EFEAE3;border-bottom-right-radius:4px;}',
    '.ac-bubble a{color:#B8A48A;text-decoration:underline;}',
    '.ac-bubble a:hover{color:#9D8A6F !important;}',
    '.ac-bubble strong{font-weight:600;}',
    '.ac-bubble em{font-style:italic;}',
    '.ac-bubble p{margin:0 0 6px 0;}',
    '.ac-bubble p:last-child{margin-bottom:0;}',
    '.ac-bubble ul{margin:4px 0;padding-left:18px;}',
    '.ac-bubble li{margin-bottom:3px;}',

    /* Schreibindikator */
    '.ac-typing{display:flex;align-items:center;gap:5px;padding:12px 14px;',
    'background:#fff;border-radius:14px;border-bottom-left-radius:4px;',
    'box-shadow:0 1px 4px rgba(0,0,0,0.09);align-self:flex-start;',
    'animation:ac-in 0.18s ease;}',
    '.ac-dot{width:7px;height:7px;border-radius:50%;background:#B8A48A;',
    'animation:ac-bounce 1.2s ease infinite;}',
    '.ac-dot:nth-child(2){animation-delay:0.2s;}',
    '.ac-dot:nth-child(3){animation-delay:0.4s;}',
    '@keyframes ac-bounce{0%,60%,100%{transform:translateY(0);opacity:0.5}',
    '30%{transform:translateY(-5px);opacity:1}}',

    /* Eingabe-Bereich */
    '#ac-input-area{padding:12px 14px;background:#fff;',
    'border-top:1px solid rgba(0,0,0,0.07);',
    'display:flex;align-items:flex-end;gap:9px;flex-shrink:0;}',
    '#ac-input{flex:1;border:1.5px solid #E8E4DE;border-radius:10px;',
    'padding:9px 12px;font-size:13.5px;font-family:inherit;color:#2C2C2C;',
    'background:#FAFAF7;resize:none;outline:none;',
    'min-height:40px;max-height:120px;overflow-y:auto;',
    'transition:border-color 0.15s ease;line-height:1.45;}',
    '#ac-input::placeholder{color:rgba(44,44,44,0.38);}',
    '#ac-input:focus{border-color:#B8A48A;}',
    '#ac-send{width:40px;height:40px;border-radius:10px;background:#1A1A1A;',
    'border:none;cursor:pointer;display:flex;align-items:center;',
    'justify-content:center;flex-shrink:0;outline:none;',
    'transition:background 0.15s ease,transform 0.1s ease;}',
    '#ac-send:hover:not(:disabled){background:#B8A48A;}',
    '#ac-send:active:not(:disabled){transform:scale(0.94);}',
    '#ac-send:disabled{opacity:0.35;cursor:not-allowed;}',

    /* Mobil */
    '@media(max-width:480px){',
    '#ac-window{bottom:0;right:0;width:100%;height:100%;border-radius:0;}',
    '#ac-trigger{bottom:16px;right:16px;}',
    '}',

    /* Produktkarten */
    '.ac-products{display:flex;flex-direction:column;gap:8px;width:100%;padding-top:2px;}',

    '.ac-product-card{display:flex;align-items:center;gap:12px;padding:10px 12px;',
    'background:#fff;border:1px solid #EFEAE3;border-radius:12px;',
    'box-shadow:0 1px 4px rgba(0,0,0,0.06);',
    'text-decoration:none;color:#2C2C2C;',
    'transition:box-shadow 0.18s ease,transform 0.18s ease;}',
    '.ac-product-card:hover{box-shadow:0 4px 16px rgba(0,0,0,0.1);transform:translateY(-1px);}',
    '.ac-product-unavailable{opacity:0.65;}',

    '.ac-product-img{width:60px;height:60px;flex-shrink:0;border-radius:8px;',
    'overflow:hidden;background:#EFEAE3;',
    'display:flex;align-items:center;justify-content:center;}',
    '.ac-product-img img{width:100%;height:100%;object-fit:cover;display:block;}',

    '.ac-product-info{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}',
    '.ac-product-name{font-size:13px;font-weight:600;color:#1A1A1A;',
    'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.ac-product-sub{font-size:11px;color:rgba(44,44,44,0.5);',
    'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.ac-product-price{font-size:13.5px;font-weight:700;color:#B8A48A;margin-top:3px;}',

    '.ac-unavail-badge{font-size:10px;font-weight:500;color:#999;',
    'background:rgba(0,0,0,0.06);border-radius:4px;padding:1px 6px;',
    'margin-top:4px;display:inline-block;letter-spacing:0.2px;}',

    /* Tabellen */
    '.aredo-chat-table{width:100%;border-collapse:collapse;margin:8px 0;',
    'font-size:13px;border-radius:8px;overflow:hidden;}',
    '.aredo-chat-table th{background:#1A1A1A;color:#FAFAF7;padding:7px 11px;',
    'text-align:left;font-weight:600;font-size:11.5px;letter-spacing:0.3px;}',
    '.aredo-chat-table td{padding:7px 11px;border-top:1px solid #EFEAE3;color:#2C2C2C;}',
    '.aredo-chat-table tbody tr:hover{background:#EFEAE3;}',
    '.aredo-chat-table td:last-child{font-weight:600;color:#B8A48A;}'
  ].join('');

  // ─── Markdown-Parser ────────────────────────────────────────────────────────
  function parseMarkdown(raw) {

    // 1. HTML-Escaping (XSS-Schutz) — vor allen anderen Transformationen
    var s = raw
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // 2. Markdown-Tabellen → HTML (VOR Inline-Formatierung, damit | nicht stört)
    s = s.replace(
      /(^\|.+\|\s*\n\|[\s:|-]+\|\s*\n(?:\|.+\|\s*\n?)+)/gm,
      function (match) {
        var lines = match.trim().split('\n').filter(function (l) { return l.trim(); });
        if (lines.length < 3) return match;

        function parseCells(line) {
          return line.trim().replace(/^\||\|$/g, '').split('|').map(function (c) { return c.trim(); });
        }

        var headers  = parseCells(lines[0]);
        var dataRows = lines.slice(2).map(parseCells);

        var thHtml = headers.map(function (h) { return '<th>' + h + '</th>'; }).join('');
        var trHtml = dataRows.map(function (row) {
          return '<tr>' + row.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
        }).join('');

        return '<table class="aredo-chat-table">'
          + '<thead><tr>' + thHtml + '</tr></thead>'
          + '<tbody>' + trHtml + '</tbody>'
          + '</table>';
      }
    );

    // 3. Markdown-Links [text](url) → <a>
    s = s.replace(
      /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#B8A48A;text-decoration:underline">$1</a>'
    );

    // 4. Nackte URLs auto-verlinken (NACH Markdown-Links — kein doppeltes Linking)
    s = s.replace(
      /(?<!href=["'])(?<!>)(https?:\/\/([^\s<]+))/g,
      function (match, fullUrl, urlWithoutProtocol) {
        var display = urlWithoutProtocol.length > 40
          ? urlWithoutProtocol.substring(0, 40) + '…'
          : urlWithoutProtocol;
        return '<a href="' + fullUrl + '" target="_blank" rel="noopener noreferrer"'
          + ' style="color:#B8A48A;text-decoration:underline">' + display + '</a>';
      }
    );

    // 5. Inline-Formatierung: Fett, kursiv, inline-code
    s = s
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/`([^`\n]+)`/g,
        '<code style="font-family:monospace;background:rgba(0,0,0,0.07);'
        + 'padding:1px 5px;border-radius:3px;font-size:12px">$1</code>');

    // 6. Zeilenweise: Headings, HR, nummerierte Listen, Aufzählungen, Absätze
    var lines  = s.split('\n');
    var html   = '';
    var para   = [];
    var inUl   = false;
    var inOl   = false;

    function flushPara() {
      if (!para.length) return;
      html += '<p style="margin:0 0 6px 0;line-height:1.55">' + para.join('<br>') + '</p>';
      para = [];
    }
    function flushLists() {
      if (inUl) { html += '</ul>'; inUl = false; }
      if (inOl) { html += '</ol>'; inOl = false; }
    }

    for (var i = 0; i < lines.length; i++) {
      var t = lines[i].trim();

      if (t === '') {
        flushPara(); flushLists();

      } else if (/^#{1,6}\s/.test(t)) {
        flushPara(); flushLists();
        var lvl      = t.match(/^(#+)/)[1].length;
        var hTag     = lvl <= 2 ? 'h4' : 'h5';
        var hText    = t.replace(/^#+\s+/, '');
        html += '<' + hTag + ' style="margin:8px 0 3px;font-weight:600;'
          + 'letter-spacing:0.2px;color:#1A1A1A;font-size:' + (lvl <= 2 ? '14' : '13') + 'px">'
          + hText + '</' + hTag + '>';

      } else if (/^[-*_]{3,}$/.test(t)) {
        flushPara(); flushLists();
        html += '<hr style="border:none;border-top:1px solid #EFEAE3;margin:8px 0">';

      } else if (/^\d+\.\s/.test(t)) {
        flushPara();
        if (inUl) { html += '</ul>'; inUl = false; }
        if (!inOl) { html += '<ol style="margin:4px 0;padding-left:20px">'; inOl = true; }
        html += '<li style="margin-bottom:3px">' + t.replace(/^\d+\.\s+/, '') + '</li>';

      } else if (/^[-•]\s/.test(t)) {
        flushPara();
        if (inOl) { html += '</ol>'; inOl = false; }
        if (!inUl) { html += '<ul style="margin:4px 0;padding-left:20px">'; inUl = true; }
        html += '<li style="margin-bottom:3px">' + t.replace(/^[-•]\s+/, '') + '</li>';

      } else {
        flushLists();
        para.push(t);
      }
    }
    flushPara(); flushLists();

    return html || '<p></p>';
  }

  // ─── Produkt-Antwort parsen (unterstützt mehrere [[PRODUCTS]]-Blöcke) ────────
  function parseReply(text) {
    const segments = [];
    const regex = /\[\[PRODUCTS\]\]([\s\S]*?)\[\[\/PRODUCTS\]\]/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      // Text vor dem Block
      if (match.index > lastIndex) {
        const textPart = text.substring(lastIndex, match.index).trim();
        if (textPart) segments.push({ type: 'text', content: textPart });
      }
      // Produkt-Block
      try {
        const products = JSON.parse(match[1].trim());
        segments.push({ type: 'products', content: products });
      } catch (e) {
        console.warn('[Aredo] Produkt-Block JSON parse failed:', e, '| Raw:', match[1]);
        segments.push({
          type: 'text',
          content: '⚠️ Die Antwort wurde leider abgeschnitten. Bitte stellen Sie eine präzisere Frage oder fragen Sie nach einer Kategorie.'
        });
      }
      lastIndex = match.index + match[0].length;
    }

    // Text nach letztem Block
    if (lastIndex < text.length) {
      const tail = text.substring(lastIndex).trim();
      if (tail) segments.push({ type: 'text', content: tail });
    }

    // Falls keine Blöcke gefunden: ganzer Text als ein Segment
    if (segments.length === 0) {
      segments.push({ type: 'text', content: text });
    }

    return segments;
  }

  var PLACEHOLDER_SVG =
    '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"' +
    ' stroke="rgba(44,44,44,0.2)" stroke-width="1.5" stroke-linecap="round">' +
    '<rect x="2" y="7" width="20" height="10" rx="2"/>' +
    '<path d="M2 12h20"/>' +
    '<line x1="7" y1="17" x2="7" y2="20"/>' +
    '<line x1="17" y1="17" x2="17" y2="20"/>' +
    '</svg>';

  function buildProductCards(products) {
    var container = document.createElement('div');
    container.className = 'ac-products';

    products.forEach(function (p) {
      var card = document.createElement('a');
      card.className = 'ac-product-card' +
        (p.available === false ? ' ac-product-unavailable' : '');
      card.href = p.url || '#';
      card.target = '_blank';
      card.rel = 'noopener noreferrer';

      // Produktbild
      var imgBox = document.createElement('div');
      imgBox.className = 'ac-product-img';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title || '';
        img.loading = 'lazy';
        imgBox.appendChild(img);
      } else {
        imgBox.innerHTML = PLACEHOLDER_SVG;
      }

      // Textinfo
      var info = document.createElement('div');
      info.className = 'ac-product-info';

      var nameEl = document.createElement('div');
      nameEl.className = 'ac-product-name';
      nameEl.textContent = p.title || '';
      info.appendChild(nameEl);

      if (p.subtitle) {
        var subEl = document.createElement('div');
        subEl.className = 'ac-product-sub';
        subEl.textContent = p.subtitle;
        info.appendChild(subEl);
      }

      var priceEl = document.createElement('div');
      priceEl.className = 'ac-product-price';
      priceEl.textContent = p.price || '';
      info.appendChild(priceEl);

      if (p.available === false) {
        var badge = document.createElement('span');
        badge.className = 'ac-unavail-badge';
        badge.textContent = 'Aktuell nicht verfügbar';
        info.appendChild(badge);
      }

      card.appendChild(imgBox);
      card.appendChild(info);
      container.appendChild(card);
    });

    return container;
  }

  // ─── Hilfsfunktionen ────────────────────────────────────────────────────────
  function scrollToBottom() {
    var msgs = document.getElementById('ac-messages');
    if (msgs) msgs.scrollTop = msgs.scrollHeight;
  }

  function autoResize(el) {
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 120) + 'px';
  }

  // ─── DOM-Aufbau ─────────────────────────────────────────────────────────────
  function buildTrigger() {
    var btn = document.createElement('button');
    btn.id = 'ac-trigger';
    btn.setAttribute('aria-label', 'Chat öffnen');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"' +
      ' stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>' +
      '</svg>';
    return btn;
  }

  function buildWindow() {
    var win = document.createElement('div');
    win.id = 'ac-window';
    win.setAttribute('role', 'dialog');
    win.setAttribute('aria-label', 'Aredo Chatbot');
    win.innerHTML =
      '<div id="ac-header">' +
        '<div class="ac-header-left">' +
          '<div class="ac-avatar">A</div>' +
          '<div class="ac-header-info">' +
            '<span class="ac-header-name">Aredo Berater</span>' +
            '<span class="ac-header-sub">Ihr persönlicher Showroom-Assistent</span>' +
          '</div>' +
        '</div>' +
        '<button id="ac-close" aria-label="Chat schliessen">' +
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"' +
          ' stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div id="ac-messages" role="log" aria-live="polite" aria-label="Chat-Verlauf"></div>' +
      '<div id="ac-input-area">' +
        '<textarea id="ac-input" rows="1" placeholder="Ihre Nachricht…"' +
        ' aria-label="Nachricht eingeben"></textarea>' +
        '<button id="ac-send" aria-label="Nachricht senden" disabled>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"' +
          ' stroke="#ffffff" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="22" y1="2" x2="11" y2="13"/>' +
          '<polygon points="22 2 15 22 11 13 2 9 22 2"/>' +
          '</svg>' +
        '</button>' +
      '</div>';
    return win;
  }

  // ─── Nachrichten darstellen ─────────────────────────────────────────────────
  function appendMessage(role, text) {
    var msgs = document.getElementById('ac-messages');
    if (!msgs) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'ac-msg ac-' + role;

    if (role === 'bot') {
      var parts = parseReply(text);
      var hasProducts = parts.some(function (p) { return p.type === 'products'; });
      if (hasProducts) wrapper.style.maxWidth = '100%';

      parts.forEach(function (part) {
        if (part.type === 'text' && part.content) {
          var bubble = document.createElement('div');
          bubble.className = 'ac-bubble';
          bubble.innerHTML = parseMarkdown(part.content);
          wrapper.appendChild(bubble);
        } else if (part.type === 'products') {
          wrapper.appendChild(buildProductCards(part.content));
        }
      });
    } else {
      var bubble = document.createElement('div');
      bubble.className = 'ac-bubble';
      bubble.innerHTML = parseMarkdown(text);
      wrapper.appendChild(bubble);
    }

    msgs.appendChild(wrapper);
    scrollToBottom();
  }

  function showTyping() {
    var msgs = document.getElementById('ac-messages');
    if (!msgs) return;
    var el = document.createElement('div');
    el.id = 'ac-typing';
    el.className = 'ac-typing';
    el.innerHTML = '<div class="ac-dot"></div><div class="ac-dot"></div><div class="ac-dot"></div>';
    msgs.appendChild(el);
    scrollToBottom();
  }

  function removeTyping() {
    var el = document.getElementById('ac-typing');
    if (el) el.remove();
  }

  // ─── API-Kommunikation ──────────────────────────────────────────────────────
  function sendMessage(text) {
    text = text.trim();
    if (isLoading || !text) return;

    isLoading = true;
    var sendBtn = document.getElementById('ac-send');
    var input = document.getElementById('ac-input');
    if (sendBtn) sendBtn.disabled = true;
    if (input) { input.value = ''; autoResize(input); }

    history.push({ role: 'user', content: text });
    appendMessage('user', text);
    showTyping();

    fetch(BACKEND + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      removeTyping();
      var reply = data.reply || 'Entschuldigung, ich konnte keine Antwort generieren.';
      console.log('[Aredo] Bot reply:', reply);
      history.push({ role: 'assistant', content: reply });
      appendMessage('bot', reply);
    })
    .catch(function (err) {
      removeTyping();
      appendMessage('bot', 'Entschuldigung, es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es in einem Moment erneut.');
      console.error('[Aredo Chat]', err);
    })
    .finally(function () {
      isLoading = false;
      var btn = document.getElementById('ac-send');
      if (btn) btn.disabled = false;
      var inp = document.getElementById('ac-input');
      if (inp) { inp.focus(); autoResize(inp); }
    });
  }

  // ─── Öffnen / Schliessen ────────────────────────────────────────────────────
  function openChat() {
    if (isOpen) return;
    isOpen = true;
    var win = document.getElementById('ac-window');
    var trigger = document.getElementById('ac-trigger');
    if (win) win.classList.add('ac-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (!welcomed) {
      welcomed = true;
      setTimeout(function () {
        appendMessage('bot', WELCOME);
        var inp = document.getElementById('ac-input');
        if (inp) inp.focus();
      }, 120);
    } else {
      var inp = document.getElementById('ac-input');
      if (inp) setTimeout(function () { inp.focus(); }, 120);
    }
  }

  function closeChat() {
    if (!isOpen) return;
    isOpen = false;
    var win = document.getElementById('ac-window');
    var trigger = document.getElementById('ac-trigger');
    if (win) win.classList.remove('ac-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  // ─── Event-Listener ─────────────────────────────────────────────────────────
  function setupEvents() {
    document.getElementById('ac-trigger').addEventListener('click', function () {
      isOpen ? closeChat() : openChat();
    });

    document.getElementById('ac-close').addEventListener('click', closeChat);

    document.getElementById('ac-send').addEventListener('click', function () {
      var inp = document.getElementById('ac-input');
      if (inp) sendMessage(inp.value);
    });

    var input = document.getElementById('ac-input');
    input.addEventListener('input', function () {
      autoResize(this);
      var btn = document.getElementById('ac-send');
      if (btn) btn.disabled = !this.value.trim() || isLoading;
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (!isLoading && this.value.trim()) sendMessage(this.value);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeChat();
    });
  }

  // ─── Initialisierung ────────────────────────────────────────────────────────
  function init() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    document.body.appendChild(buildTrigger());
    document.body.appendChild(buildWindow());

    setupEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
